module.exports = __webpack_public_path__ + "static/bradesco-5-9f7e102ddd8533320c52fc35ccdc2ba3.jpg";